import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// project imports
import useAuth from "hooks/useAuth";
import Loader from "ui-component/Loader";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate("/login", { replace: true });
    }
  }, [isInitialized, isLoggedIn, navigate]);

  if (!isInitialized) {
    return <Loader />;
  }

  return isLoggedIn ? children : null;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
